import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getTourCategoriesInput,
  getTourCategoryInput,
  TourCategoryLiteModel,
  TourCategoryModel,
} from './model';

export function useGetTourCategories(
  input?: getTourCategoriesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<TourCategoryLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<TourCategoryLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['tour-categories', input?.params],
      () =>
        QueryFetchFunction({
          url: 'tour-categories',
          params: input?.params,
        }),
      options,
    ),
    TourCategoryLiteModel,
  );
}

export function useGetTourCategory(
  input?: getTourCategoryInput,
  options?: UseQueryOptions<ApiResult<TourCategoryModel>, ApiError>,
): UseQueryResult<ApiResult<TourCategoryModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      ['tour-categories', input?.id],
      () =>
        QueryFetchFunction({
          url: `tour-categories/${input?.id}`,
        }),
      options,
    ),
    TourCategoryModel,
  );
}

export function getTourCategoriesKey(input?: getTourCategoriesInput) {
  return ['tour-categories', input?.params].filter(Boolean);
}
export function getTourCategoryKey(input?: getTourCategoryInput) {
  return ['tour-category', input?.id].filter(Boolean);
}
